import * as Sentry from '@sentry/browser';
import {
    getCaptchaV3TimeoutReached,
    getCaptchaV3Token,
    getIsCaptchaV3Initialized,
} from '../../../selectors/app';
import { isRecaptchaV3Enabled } from '../../../selectors/splitio';
import { getTicketsCostDetails } from '../../../selectors/tickets/getDisplayCostProps';
import { hasOnlyAddOnsSelected } from '../../../selectors/tickets/hasOnlyAddOnsSelected';
import { CheckoutState } from '../../../state';

export const getEnableCaptchaAndRejectUser = (state: CheckoutState) => {
    if (
        getTicketsCostDetails(state).totalCostInCents > 0 ||
        !isRecaptchaV3Enabled(state) ||
        hasOnlyAddOnsSelected(state)
    ) {
        return { rejectUser: false, enableCaptcha: false };
    }

    if (getCaptchaV3Token(state)) {
        return { rejectUser: false, enableCaptcha: true };
    }

    // If Captcha was not initialised and timeout was not reached
    // this could be an attack
    const suspiciousActor = !(
        getIsCaptchaV3Initialized(state) && getCaptchaV3TimeoutReached(state)
    );

    if (suspiciousActor) {
        Sentry.captureMessage('Captcha - Suspicious actor');
    }

    return {
        rejectUser: suspiciousActor,
        enableCaptcha: false,
    };
};
